import { useEffect,useState, } from "react"
import sharedDatas from "../../businessLogic/sharedDatas";
import { useMutation,useSnackbar} from "@1f/react-sdk";
import { DataGridPro,GridToolbar,itIT } from '@mui/x-data-grid-pro';

//Custom components
import { Loading } from "../Loading";

import Paper from '@mui/material/Paper';
import { mutation_getLegalRepresentatives } from "../../businessLogic/mutations/anagraficaFascicoloMutations";
import VaporTag from "@vapor/react-custom/VaporTag";
import { chipGreen, chipRed } from "../../businessLogic/styles";
import { LogApi } from "../../businessLogic/api/logApi";


export const LegaliRappresentantiList = ({fascicolo,cessato,onSelection}) => {
    const loggedUserId = sharedDatas.getPropertyByName("userId");
    const paginationModel = { page: 0, pageSize: 5 };
    const logApi = LogApi()
    const { enqueueSnackbar } = useSnackbar();

    //#region Mutation
    const apiGetLegalRapprByFascicoloId = useMutation(
        mutation_getLegalRepresentatives,
        {graphqlEndpoint: "aml:hasura:api://v1/graphql"}
    )
    //#endregion    

    //#region UseState
    const [backDropOpen, setBackDropOpen] = useState(true); //Loader utilizzato durante il caricamento
    const [, setIsDataLoaded] = useState(false); //Indica lo stato di caricamento del result Api
    const [legalRapprList, setLegalRapprList] = useState([]); //Collezione dei legali rappresentanti riguardanti al fascicolo
    const columns = [
        { field: 'first_name', headerName : 'Nome', flex:0.5},
        { field:'last_name', headerName: 'Cognome', flex: 0.3},       
        { 
            field:'identification_date',
            headerName: 'Data di identificazione',  
            flex:0.3           
        },        
        {   field: 'rule_is_terminated',
            headerName: 'Stato', flex:0.5,
            renderCell: (params) => renderColorCell(params.row),
            valueGetter : (params) => renderColorCellGetter(params.row)}
    ]; 
    //#endregion

    //#region Render
    const renderColorCell = (item)=>{
        if(item.rule_is_terminated){
            return <VaporTag variant='standard' label='Cessato' sx={chipRed} />;
        } else {
            return <VaporTag variant='standard' label='Attivo' sx={chipGreen} />;
        }
    }
    const renderColorCellGetter = (item) => {
        if(item.rule_is_terminated){
            return "Cessato"
        } else {
            return "Attivo"
        }
    }
    //#endregion

    useEffect (()=>{        
        loadDatas()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cessato])

    async function loadDatas(){        
        try{                       
            setBackDropOpen(true)
            const response = await apiGetLegalRapprByFascicoloId.fetch({
                fascicoloId : fascicolo.id,
                userId : loggedUserId,
                isTerminated : cessato
            })           
            
            let allLegalRappr = []
            response.data.data.getLegalRepresentatives.response.persons.forEach(person => {
                allLegalRappr.push(person)
            });            
            setLegalRapprList(allLegalRappr)            
        } catch (graphQlError){
            enqueueSnackbar("Impossibile caricare i legali rappresentanti", { variant: "error" });            
            logApi.AddLog(graphQlError.originalError.extensions.internal, graphQlError.stack, "loadDatas","LegaliRappresentantiList")
        } finally {
            setBackDropOpen(false)
            setIsDataLoaded(true)
        }                
    }

    const handleRowSelection = (event) => {                  
        onSelection(event)
    }

    return (        
        <Paper sx={{width : '100%'}}>
            <Loading open={backDropOpen} />
            <DataGridPro 
                rows={legalRapprList}
                columns={columns}
                initialState={{pagination : paginationModel}}
                slots={{ toolbar: GridToolbar }}
                autoHeight={true}
                localeText={
                    itIT.components.MuiDataGrid.defaultProps.localeText
                }
                pageSizeOptions={[5,10]}                
                checkboxSelection                
                onRowSelectionModelChange={handleRowSelection}
                sx={{border: 0}}
                slotProps={{
                    toolbar: { printOptions: { disableToolbarButton: true } },
                }}                
            />
        </Paper>
    )
}